import React from 'react'
import classNames from 'classnames'
import DemoForm from '@toasttab/main/src/components/DemoForm/DemoForm'
import Eyebrow from '@toasttab/shared/src/components/molecules/Eyebrow/Eyebrow'
import TextLink from '@toasttab/shared/src/components/molecules/TextLink/TextLink'
import Typography from '@toasttab/shared/src/components/atoms/Typography/Typography'
import Video from '@toasttab/shared/src/components/atoms/Video/Video'
import { resolvePrefix } from '@toasttab/shared/src/utils/assetUtils'
import HeroModal from './HeroModal'

interface iconProps {
  position?: string
  width?: string
  height?: string
  src: string
}

interface videoProps {
  classes?: string
  heapInteraction?: string
  image: imageProps[]
  imageClasses: string
  inverseButton?: boolean
  key: string
  sectionHeading?: string
  vidyardId: string
}

interface imageProps {
  filename?: string
  url?: string
  extension?: string
}

const HeroVariant = ({ body }: { body: any }) => {
  const modalInput = body.columns.left.modal.modalInput
  const modalInputButton = body.columns.left.modal.inputButton

  const eyebrowIcon: iconProps = {
    src: resolvePrefix(body.columns.left.eyebrow.icon),
    width: '24',
    height: '24'
  }
  const image: imageProps = {
    extension: 'mp4',
    filename: body.columns.right.video.filename,
    url: resolvePrefix(body.columns.right.video.posterImageUrl)
  }
  const video: videoProps = {
    classes:
      'lg:bg-brand-50 lg:shadow-hp-video-frame lg:p-2 lg:rounded-[1.875rem] lg:h-full',
    heapInteraction: 'hprefine_videoplaybtn_click',
    image: image ? [image] : [],
    imageClasses: 'lg:h-full lg:object-cover relative rounded-[1.5rem]',
    inverseButton: true,
    key: body.columns.right.video.vidyardId,
    sectionHeading: body.columns.right.video.playButton.text,
    vidyardId: body.columns.right.video.vidyardId
  }

  const sectionStyles = classNames(
    'mb-10 rounded-[1.4rem] relative -top-2',
    'lg:bg-gradient-to-b lg:from-[#F9F9F9] lg:to-[#F8F2F2] lg:rounded-none lg:rounded-b-[3rem] lg:mb-16 lg:py-20'
  )

  const wrapperStyles = classNames('ds-wrapper')

  const containerStyles = classNames('ds-container lg:ds-grid lg:gap-12')

  const brandLineStyles = classNames(
    'col-span-4 lg:col-span-6 mb-6 lg:mb-0',
    'bg-brand-50 bg-hp-brand-line-Mobile  rounded-[1.5rem] -mx-4 md:-mx-6 lg:-mx-0',
    'lg:bg-none lg:bg-transparent p-6 lg:p-0 lg:rounded-none',
    'before:content-[""] before:w-full before:h-full before:absolute before:top-0 before:left-0 before:bg-top-brand-50-gradient before:rounded-[1.5rem]',
    'lg:before:bg-none'
  )
  return (
    <section className={sectionStyles} data-interaction='cro_HPdesktopform_ab'>
      <div className={wrapperStyles}>
        <div className={containerStyles}>
          <div className={brandLineStyles}>
            <div className='lg:bg-none lg:mb-6 relative z-20'>
              <Eyebrow
                componentClass='hidden lg:block'
                icon={eyebrowIcon}
                variation='pos-hp'
              >
                {body.columns.left.eyebrow.text}
              </Eyebrow>
              <Typography
                allowHtml={false}
                as='h1'
                classes='font-effra font-normal !text-[2.375rem] lg:!text-[64px] text-center lg:text-left text-white lg:text-default !leading-[2.375rem] lg:!leading-[4rem] mb-4'
                variation='h1'
              >
                {body.columns.left.heading}
              </Typography>
              <Typography
                allowHtml={false}
                as='h4'
                classes='!font-effra !font-normal !text-[1.125rem] lg:!text-[1.625rem] text-center lg:text-left text-white lg:text-secondary !leading-[1.5rem] lg:!leading-[1.688rem] mb-6 hidden lg:block'
                variation='h4'
              >
                {body.columns.left.description}
              </Typography>
              <Typography
                allowHtml={false}
                as='h4'
                classes='!font-effra !font-normal !text-[1.125rem] lg:!text-[1.625rem] text-center lg:text-left text-white lg:text-secondary !leading-[1.5rem] lg:!leading-[1.688rem] mb-6 lg:mb-8 block lg:hidden'
                variation='h4'
              >
                {body.columns.left.descriptionMobile}
              </Typography>
              <div className='bg-white block lg:hidden rounded-[0.625rem] p-6'>
                <Typography
                  allowHtml={false}
                  as='h3'
                  classes='font-effra font-normal text-[2.688rem] leading-[3rem] mb-6 text-primary'
                  variation='h3'
                >
                  {body.columns.left.form.heading}
                </Typography>
                <DemoForm
                  fieldIdPrefix='ContentfulHomepageHeroDemoRequest'
                  formData={body.columns.left.form.data}
                  privacyStatementCenter={false}
                  useRecaptcha={false}
                />
              </div>
            </div>
            <div className='hidden lg:block'>
              <HeroModal
                buttonText={modalInputButton}
                input={modalInput}
                modal={body.columns.left.modal}
              />
            </div>
            {Boolean(
              body.columns.left?.link?.text && body.columns.left?.link?.url
            ) && (
              <TextLink
                classes='relative'
                heading={body.columns.left?.link?.heading}
                heapInteraction={body.columns.left?.link?.heapInteraction}
                href={body.columns.left?.link?.url}
                icon='arrow'
                isDisplayedBlock
                text={body.columns.left?.link?.text}
                wrapperClasses='mt-4 hidden lg:block '
              />
            )}
          </div>
          <div className='col-span-4 lg:col-span-6 relative'>
            <Video {...video} />
          </div>
        </div>
      </div>
    </section>
  )
}

export default HeroVariant
